// Custom assets keep one script per mode (`scriptTts` / `scriptSts`) so that
// toggling TTS↔STS never clobbers what the talent typed in the other mode.
// The typical flow, though, is "TTS doesn't get me there, I'll speak it
// myself" — so on a switch the still-empty target inherits the source
// script. A target with its own content is left alone (GitHub #1, point 5).

export type ScriptCarry = { field: 'scriptTts' | 'scriptSts'; value: string };

export function carryScriptOnModeSwitch(
  next: 'tts' | 'sts',
  ttsScript: string,
  stsScript: string,
): ScriptCarry | null {
  const source = next === 'sts' ? ttsScript : stsScript;
  const target = next === 'sts' ? stsScript : ttsScript;
  if (target.trim() || !source.trim()) return null;
  return { field: next === 'sts' ? 'scriptSts' : 'scriptTts', value: source };
}
